import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/** Markdown 教程预览（GFM：表格 / 任务列表 / 删除线等） */
export default function PlatformTutorialMarkdownPreview({ content = '' }) {
  return (
    <div className="pt-preview__markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {content || ''}
      </ReactMarkdown>
    </div>
  );
}
